import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { performLogout } from '../utils/logout';
import { trackSignOut } from '../lib/eventTracker';
import { removeCoupon } from '../features/cart/couponSlice';

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userID = useSelector((state) => state.user?.data?.userID);

  const logout = ({ onClose, redirectTo = '/login', replace = true } = {}) => {
    dispatch(performLogout());

    trackSignOut(userID);

    toast.success('Logged Out Successfully', {
      className:
        'bg-[var(--yellow-primary)] text-black text-sm rounded-md min-h-0',
    });

    if (onClose) {
      onClose();
    }
    dispatch(removeCoupon());

    navigate(redirectTo, { replace });
  };

  return logout;
};
